(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-giveaway"] && !Shopify.designMode) return;
  try {
    
function dockBodalowcostWheel() {
  const trigger = document.getElementById('spinwheel-floating-button');
  const slot = document.querySelector('[data-bc-wheel-slot]');
  if (trigger && slot && trigger.parentElement !== slot) {
    slot.appendChild(trigger);
    const fallback = slot.querySelector('[data-bc-open-wheel]');
    if (fallback) fallback.hidden = true;
  }
}
dockBodalowcostWheel();
new MutationObserver(dockBodalowcostWheel).observe(document.body, { childList: true, subtree: true });
document.addEventListener('shopify:section:load', dockBodalowcostWheel);
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-bc-open-wheel]');
  if (!link) return;
  const trigger = document.getElementById('spinwheel-floating-button');
  if (trigger) {
    event.preventDefault();
    trigger.click();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bc-hero-edit"] && !Shopify.designMode) return;
  try {
    
function bcInitHeroVideos() {
  document.querySelectorAll('[data-bc-hero-video]').forEach(video => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    const button = video.parentElement.querySelector('[data-bc-video-toggle]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let requested = false;
    function load() {
      if (!requested) { video.src = video.dataset.src; requested = true; video.muted = true; }
    }
    function play() { load(); video.play().catch(() => { button.hidden = false; button.textContent = button.dataset.play; }); }
    video.addEventListener('playing', () => { video.classList.add('bc-video-ready'); button.hidden = false; button.textContent = button.dataset.pause; });
    video.addEventListener('pause', () => { button.textContent = button.dataset.play; });
    video.addEventListener('error', () => { video.classList.remove('bc-video-ready'); button.hidden = true; });
    button.addEventListener('click', () => { if (video.paused) play(); else video.pause(); });
    if (motion.matches || navigator.connection?.saveData) { button.hidden = false; button.textContent = button.dataset.play; return; }
    const poster = video.parentElement.querySelector('img');
    const begin = () => { if ('requestIdleCallback' in window) window.requestIdleCallback(play, { timeout: 1500 }); else window.setTimeout(play, 150); };
    if (poster.complete) begin(); else { poster.addEventListener('load', begin, { once: true }); poster.addEventListener('error', begin, { once: true }); }
  });
}
bcInitHeroVideos();
document.addEventListener('shopify:section:load', bcInitHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
